import React from 'react';
import PropTypes from 'prop-types';
import MarketplaceBarItem from './MarketplaceBarItem';
import {Message} from '@aperza/ui';
import AppService from '../service/AppService';
import type AppConfig from '../domain/AppConfig';
const appConfig:AppConfig = AppService.appConfig();

export default class MarketplaceBar extends React.Component {

  render() {

    let url = `https://www.aperza.com/corp/contact/aperza`;

    return (
      <div className="marketplace-bar">
        <img className="marketplace-bar-img" useMap="#marketplacemap" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" />
        <map name="marketplacemap">
          <area shape="rect" coords="914,16,962,30" href={url} target="_blank" />
        </map>
      </div>
    )
  }

}
